export const INITIAL_WIZARD_INFO_TEXT = "Välj bland alternativen ovan för att filtrera fram den kopplingsprincip och produktlinje som passar bäst för dina behov, eller dubbelklicka på något av resultaten för att gå vidare direkt.";
export const WIZARD_TAB1_SELECTED_TEXT = "Välj en eller flera kopplingsprinciper och klicka vidare till steg 2 för ytterligare vägledning."

